import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let selectionId: string | null = null;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI.registerOnSelection((selectedItem) => {
      console.log("onSelection", selectedItem);
      if (selectedItem.item == null) {
        selectionId = null;
      } else {
        selectionId =
          selectedItem.item.modelId + ":" + selectedItem.item.modelItemId;
      }
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_reframe() {
  LwAPI?.reframe();
}

function ex_reframeItem() {
  if (selectionId) {
    LwAPI?.reframe(selectionId);
  }
}
// Bind functions to buttons
document.getElementById("reframeitem")?.addEventListener("click", async () => {
  await apiReady;
  ex_reframeItem();
});
document.getElementById("reframe")?.addEventListener("click", async () => {
  await apiReady;
  ex_reframe();
});
